export const TEXTAREA_SIZE = ['small', 'medium', 'large'] as const

export const TEXTAREA_CONTAINER = 'TEXTAREA_CONTAINER'
